import { useState } from "react"
import API from "../../API";
import { useNavigate } from "react-router-dom";
import useSesion from "../Sesion";
import { notification } from "antd";
export function useInstitucion() {
    const navigate=useNavigate()
    const {usuario} = useSesion()
    const [instituciones, setInstituciones] = useState([])
    const [cargando,setCargando] = useState(false)

    const getAllInstitucion=async ()=>{
            setCargando(true)
            try {
                const {data} = await API('institucion')
                setInstituciones(data?.docs ?? [])
            } finally {
                setCargando(false)
            }
    }

    /**
     * Carga una institución por id (siempre desde API cuando hay id).
     * Sin id: solo Admin ve placeholder en inicio; el resto deja lista vacía.
     * @returns {object|null} documento cargado o null
     */
    const getInstitucion = async (id) => {
        if (id == null || id === "") {
            if (usuario?.rol === "Admin") {
                setInstituciones([{ nombre: "Sefum Admin" }]);
            } else {
                setInstituciones([]);
            }
            return null;
        }
        const { data } = await API(`institucion/${id}`);
        const doc = data?.doc ?? null;
        if (doc) {
            setInstituciones([doc]);
        }
        return doc;
    };
    const eliminar=async (id)=>{
        try{
            setCargando(true)
            const url = `institucion/${id}`
            const method = "delete"
            //console.log(url)
            await API({
                url,
                method
            })
        }catch(err){
            console.log(err)
        }finally{
            setCargando(false)
            getAllInstitucion()
        }
    }
    const guardar = async (data, idActualizar) => {
        try {
            setCargando(true);
            if (idActualizar) {
                await API({
                    url: `institucion/${idActualizar}`,
                    method: "patch",
                    data,
                });
                notification.success({ description: "Institución actualizada" });
            } else {
                await API({
                    url: "institucion/",
                    method: "post",
                    data,
                });
                notification.success({ description: "Institución creada" });
            }
            navigate("/instituciones");
        } catch (error) {
            notification.error({
                description: error?.response?.data?.mensaje || error?.message || "No se pudo guardar",
            });
        } finally {
            setCargando(false);
        }
    };
    
    const editInstitucion = async (id)=>{
        try{
            setCargando(true)
            const {data} = await API(`institucion/${id}`)
            setInstituciones([data.doc])
        }catch(err){
            //console.log(err)
        }finally{
            setCargando(false)
        }

    }
    
  

    return {
        instituciones,
        getInstitucion,
        guardar,
        editInstitucion,
        getAllInstitucion,
        cargando,
        eliminar
    }
}
